enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}
interface ToastModel {
  message: string;
  type: ToastType;
}

interface CreateResponseModel {
  id: number;
  success: boolean;
}

interface SuccessResponseModel {
  success: boolean;
}

interface CreateEntityResponseModel {
  entityId: string;
  success: boolean;
}

export { ToastType };
export type { CreateEntityResponseModel, CreateResponseModel, SuccessResponseModel, ToastModel };
